/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryForUserBackendInfo
 */
export interface CountryForUserBackendInfo {
    /**
     * 
     * @type {string}
     * @memberof CountryForUserBackendInfo
     */
    timeZone: string;
    /**
     * 
     * @type {string}
     * @memberof CountryForUserBackendInfo
     */
    iso2: string;
}

export function CountryForUserBackendInfoFromJSON(json: any): CountryForUserBackendInfo {
    return CountryForUserBackendInfoFromJSONTyped(json, false);
}

export function CountryForUserBackendInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryForUserBackendInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timeZone': json['time_zone'],
        'iso2': json['iso2'],
    };
}

export function CountryForUserBackendInfoToJSON(value?: CountryForUserBackendInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time_zone': value.timeZone,
        'iso2': value.iso2,
    };
}


